


















import { Component, Prop, Vue } from "vue-property-decorator";
import { Item } from "@/types/list";

@Component({
  components: {},
})
export default class Detail extends Vue {
  @Prop(Function) dialogClose!: () => void;
  @Prop(Object) currentRow!: Item;

  dialogVisible = true;

  handleClose(): void {
    this.dialogVisible = false;
    this.dialogClose();
  }
}
